/* eslint-disable indent */
/* eslint-disable react/jsx-indent */
import { useEffect, useState } from 'react';
import { QuestionIcon } from '@chakra-ui/icons';
import {
  Box,
  Button,
  Card,
  CardBody,
  Checkbox,
  Code,
  Flex,
  Heading,
  Icon,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  StackDivider,
  Text,
  Tooltip,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { updateActiveStep as updateManualVerificationActiveStep } from '../../../../redux/manualVerification/stepperDetails';
import {
  updateDynamicBodyValues,
  updateDynamicURLValues,
} from '../../../../redux/manualVerification/temporaryDetails';
import { getManualVerificationDynamicBodyValues } from '../../../../redux/manualVerification/temporaryDetails/selectors';
import { updateExpandedPaths } from '../../../../redux/providerBuilder/jsonViewer';
import { updateProviderDetails } from '../../../../redux/providerBuilder/providerDetails';
import { getProviderDetails } from '../../../../redux/providerBuilder/providerDetails/selectors';
import { getSelectedInstances } from '../../../../redux/providerBuilder/selectedInstances/selectors';
import { updateSelectedNetworkRequest } from '../../../../redux/providerBuilder/selectedNetworkRequest';
import {
  getSelectedNetworkIndex,
  getSelectedNetworkRequest,
} from '../../../../redux/providerBuilder/selectedNetworkRequest/selectors';
import {
  getAllDynamicPaths,
  getAllPaths,
  getValueByPath,
  setValueByPath,
} from '../../../../utils/provider-builder/instance-selection-utils';
import { extractDomain } from '../../../../utils/provider-builder/proof-card-utils';
import {
  getDefaultProofCardText,
  initializeRegexBody,
  seperateURLComponents,
  urlSpanToRegexUrl,
  URLSpanType,
} from '../../../../utils/provider-builder/request-config-utils';
import NormalJsonViewerScreen from '../../../provider-builder/components/request-selection/normal-json-viewer-screen';

export const ManualVerificationRequestConfigScreen = () => {
  const toast = useToast();
  const dispatch = useAppDispatch();

  // const params = useParams()
  // const navigate = useNavigate()

  const selectedNetworkRequest = useAppSelector(getSelectedNetworkRequest);
  const selectedNetworkIndex = useAppSelector(getSelectedNetworkIndex);
  const selectedInstances = useAppSelector(getSelectedInstances);
  const providerDetails = useAppSelector(getProviderDetails);
  // const sessionId = useAppSelector(getManualVerificationSelectedSessionId)
  // const selectedSessionData = useAppSelector(getSelectedManualVerificationSessionData)

  const dynamicBodyValues = useAppSelector(getManualVerificationDynamicBodyValues);

  const [urlSpans, setUrlSpans] = useState<any>([]);
  const [regexBody, setRegexBody] = useState('');
  const [selectedText, setSelectedText] = useState<any>(null);
  const [buttonLoading, setButtonLoading] = useState(false);

  useEffect(() => {
    if (selectedNetworkRequest) {
      if (
        providerDetails?.httpProviderId?.length &&
        providerDetails?.url ===
          selectedNetworkRequest[selectedNetworkIndex]?.templateUrl &&
        providerDetails?.method === selectedNetworkRequest[selectedNetworkIndex]?.method
      ) {
        if (selectedNetworkRequest[selectedNetworkIndex]?.urlSpans?.length) {
          const urlSpans = [...selectedNetworkRequest[selectedNetworkIndex]?.urlSpans];
          setUrlSpans(urlSpans);
        } else {
          const newUrlSpans = seperateURLComponents(
            selectedNetworkRequest[selectedNetworkIndex]?.url
          );
          setUrlSpans(newUrlSpans);
        }

        const regexBody = providerDetails?.bodySniff?.template;

        try {
          if (regexBody !== '') {
            const data = JSON.parse(regexBody);
            const expandedPaths = getAllPaths('', data, '');
            expandedPaths[''] = true;
            dispatch(updateExpandedPaths(expandedPaths));
          }
        } catch (error) {
          console.log(error);
        } finally {
          setRegexBody(regexBody);
        }
      } else {
        const newUrlSpans = seperateURLComponents(
          selectedNetworkRequest[selectedNetworkIndex]?.url
        );
        setUrlSpans(newUrlSpans);
        const newRegexBody = initializeRegexBody(
          selectedNetworkRequest[selectedNetworkIndex]?.request?.body
        );
        if (
          selectedNetworkRequest[selectedNetworkIndex]?.contentType?.includes('json') &&
          newRegexBody?.length
        ) {
          try {
            const data = JSON.parse(newRegexBody);
            const expandedPaths = getAllPaths('', data, '');
            expandedPaths[''] = true;
            dispatch(updateExpandedPaths(expandedPaths));
          } catch (error) {
            console.log(error, '>>>', { newRegexBody });
          }
        }

        setRegexBody(newRegexBody);
      }
    }
  }, [selectedNetworkRequest]);

  // useEffect(() => {
  //     handleClaimSubmit()
  // }, [providerDetails])

  // async function handleClaimSubmit() {
  //     if (buttonLoading) {
  //         await editHttpProvider()
  //         setButtonLoading(false)
  //     }
  // }

  // async function editHttpProvider() {
  //     try {
  //         const accessToken = (await getFirebaseIdToken()) ?? ''

  //         const payload: ProviderDetails = {
  //             ...providerDetails,
  //         }
  //         const message1 = await editProvider(payload, accessToken)

  //         if (selectedSessionData?.status === 'PENDING') {
  //             const paramValues = createParamValues(selectedInstances, dynamicURLValues, dynamicBodyValues)
  //             const message2: any = await updateManualVerificationSession(accessToken, sessionId, 'VERIFIED', paramValues)
  //             if (!message2.isSuccess) {
  //                 toast({
  //                     title: 'Error',
  //                     description: 'something went wrong',
  //                     status: 'error',
  //                     duration: 3000,
  //                     isClosable: true,
  //                     position: 'top-right',
  //                 })
  //                 return
  //             }
  //         }

  //         if (!message1.isSuccess) {
  //             toast({
  //                 title: 'Error',
  //                 description: 'something went wrong',
  //                 status: 'error',
  //                 duration: 3000,
  //                 isClosable: true,
  //                 position: 'top-right',
  //             })
  //             return
  //         } else {
  //             toast({
  //                 title: 'Successfull',
  //                 description: '',
  //                 status: 'success',
  //                 duration: 3000,
  //                 isClosable: true,
  //                 position: 'top-right',
  //             })
  //             dispatch(resetProviderDetails())
  //             dispatch(resetNetworkStore())
  //             dispatch(resetSelectedInstances())
  //             dispatch(resetSelectedNetworkRequest())
  //             dispatch(resetSelectedManualVerificationSessionData())
  //             setButtonLoading(false)

  //             if (params?.sessionId?.length) {
  //                 dispatch(setSelectedSessionId(''))
  //                 dispatch(updateManualVerificationActiveStep(1))
  //                 navigate('/manual-verification')
  //             } else {
  //                 dispatch(updateManualVerificationActiveStep(2))
  //             }
  //         }

  //     } catch (e) {
  //         toast({
  //             title: 'Error',
  //             description: 'something went wrong',
  //             status: 'error',
  //             duration: 3000,
  //             isClosable: true,
  //             position: 'top-right',
  //         })
  //     }
  // }

  function handleGoBack() {
    dispatch(updateManualVerificationActiveStep(4));
  }

  function toggleSelectedUrlSpan(index: number) {
    if (urlSpans[index].type !== 'STATIC') {
      let paramsCount = 1;
      const totalLength = urlSpans.length;
      const tempURLValues: any = {};

      const updatedUrlSpans = urlSpans.map((url: any) => ({ ...url }));

      updatedUrlSpans.forEach((url: any, i: number) => {
        if (index === i) {
          if (url.type?.includes('URL_PARAMS')) {
            updatedUrlSpans[i].type = URLSpanType.CONSTANT;
          } else if (url.type === URLSpanType.CONSTANT) {
            // Check if the selected index is the last in the array
            if (index === totalLength - 1) {
              updatedUrlSpans[i].type = '{{URL_PARAMS_GRD}}';
              tempURLValues['{{URL_PARAMS_GRD}}'] = updatedUrlSpans[i].key;
            } else {
              updatedUrlSpans[i].type = `{{URL_PARAMS_${paramsCount++}}}`;
              tempURLValues[`{{URL_PARAMS_${paramsCount - 1}}}`] = updatedUrlSpans[i].key;
            }
          }
        } else if (url.type?.includes('URL_PARAMS') && index !== i) {
          if (i === totalLength - 1) {
            updatedUrlSpans[i].type = '{{URL_PARAMS_GRD}}';
            tempURLValues['{{URL_PARAMS_GRD}}'] = updatedUrlSpans[i].key;
          } else {
            updatedUrlSpans[i].type = `{{URL_PARAMS_${paramsCount++}}}`;
            tempURLValues[`{{URL_PARAMS_${paramsCount - 1}}}`] = updatedUrlSpans[i].key;
          }
        }
      });
      dispatch(updateDynamicURLValues({ ...tempURLValues }));
      setUrlSpans(updatedUrlSpans);
    }
  }

  function handleJsonKeyClick(clickedPath: string, checked: boolean = false) {
    const jsonObject = JSON.parse(regexBody);
    const tempBodyValues: any = {};
    const allDynamicPaths = getAllDynamicPaths(
      '',
      jsonObject,
      '',
      {},
      false,
      clickedPath,
      checked
    );

    for (const dynamicPath in allDynamicPaths) {
      let value = allDynamicPaths?.[dynamicPath] ?? '{{REQ_BODY_1}}';
      const orginalJSON = JSON.parse(
        selectedNetworkRequest[selectedNetworkIndex]?.request?.body
      );

      let skipDynamicValue = false;

      if (value === 'ORIGINAL_VALUE') {
        value = getValueByPath(orginalJSON, dynamicPath);
        skipDynamicValue = true;
      }

      if (!skipDynamicValue) {
        tempBodyValues[value] = getValueByPath(orginalJSON, dynamicPath);
      }

      setValueByPath(jsonObject, dynamicPath.substring(1), value);
    }

    const updatedJsonString = JSON.stringify(jsonObject);
    dispatch(updateDynamicBodyValues({ ...tempBodyValues }));
    setRegexBody(updatedJsonString);
  }

  function resetRegexBody() {
    const newRegexBody = initializeRegexBody(
      selectedNetworkRequest[selectedNetworkIndex]?.request?.body
    );
    dispatch(updateDynamicBodyValues({}));
    setRegexBody(newRegexBody);
    setSelectedText(null);
  }

  // replace the selected text in the body and make it dynamic
  function handleReplaceRegexBody() {
    // Replace the selected text with the replacement text
    if (selectedText?.toString()?.length) {
      let startOffset = selectedText.anchorOffset;
      let endOffset = selectedText.focusOffset;

      const tempDynamicBodyValues = { ...dynamicBodyValues };

      if (startOffset > endOffset) {
        const endTemp = endOffset;
        endOffset = startOffset;
        startOffset = endTemp;
      }

      let prevRegexBody = regexBody;
      const prefix = prevRegexBody.slice(0, startOffset);
      const suffix = prevRegexBody.slice(endOffset);

      const specialString = '{{REQ_BODY_999}}';
      prevRegexBody = `${prefix}${specialString}${suffix}`;

      let paramsCounter = 1;
      const dynamicVariables = prevRegexBody.match(/{{REQ_BODY_\d+}}/g) ?? [];

      tempDynamicBodyValues[`{{REQ_BODY_${dynamicVariables?.length}}}`] =
        selectedText?.toString();

      if (dynamicVariables) {
        for (const dynamicVariable of dynamicVariables) {
          prevRegexBody = prevRegexBody.replace(
            dynamicVariable,
            `{{REQ_BODY_${paramsCounter}}}`
          );
          paramsCounter++;
        }
      }

      setRegexBody(prevRegexBody);

      dispatch(
        updateDynamicBodyValues({
          ...dynamicBodyValues,
          ...tempDynamicBodyValues,
        })
      );
      setSelectedText(null);
    } else {
      toast({
        title: 'No text selected',
        description: 'Select the text you want to make dynamic from the body',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      });
    }
  }

  // Makes all body content as dynamic in regex body
  function makeFullBodyDynamic() {
    setRegexBody('{{REQ_BODY_GRD_1}}');
    const newRegexBody = initializeRegexBody(
      selectedNetworkRequest[selectedNetworkIndex]?.request?.body
    );
    dispatch(updateDynamicBodyValues({ '{{REQ_BODY_GRD_1}}': newRegexBody }));
    setSelectedText(null);
  }

  // set selected text to the selectedText state
  function handleTextSelect() {
    const selection = window.getSelection();
    if (selection !== null) {
      setSelectedText(selection);
    }
  }

  function handleNext() {
    setButtonLoading(true);
    const templateUrl = urlSpanToRegexUrl(urlSpans);
    const responseSelections = selectedInstances.map(
      (instance: any) => instance.responseSelection
    );

    const bodyEnabled = !!selectedNetworkRequest[selectedNetworkIndex]?.request?.body;
    const finalTemplateBody = regexBody;

    const proofCardText = getDefaultProofCardText(selectedInstances);
    const domainName = extractDomain(selectedNetworkRequest[selectedNetworkIndex]?.url);
    const proofCardTitle = domainName;

    dispatch(
      updateSelectedNetworkRequest({
        urlSpans,
        templateUrl,
      })
    );

    dispatch(
      updateProviderDetails({
        url: templateUrl,
        urlType: 'TEMPLATE',
        bodySniff: {
          enabled: bodyEnabled,
          regex: '',
          template: bodyEnabled ? finalTemplateBody : '',
        },
        proofCardText: proofCardText,
        proofCardTitle: proofCardTitle,
        verificationType: 'WITNESS',
        responseSelections,
      })
    );
    setButtonLoading(false);
    dispatch(updateManualVerificationActiveStep(6));
  }

  const renderUrlSpans = (urlSpans: any) => {
    const spans = [];
    let i = 0;
    let j = 0;

    while (i < urlSpans.length) {
      const span = urlSpans[i];

      if (span.key === '/') {
        i++;
        continue;
      }

      if (span.key === '?' || span.key === '&') {
        let query = span.key;

        if (span.type?.includes('URL_PARAMS')) {
          query = span.type;
        }

        i++;
        while (
          i < urlSpans.length &&
          urlSpans[i].key !== '?' &&
          urlSpans[i].key !== '&' &&
          urlSpans[i].key !== '/'
        ) {
          if (urlSpans[i].type?.includes('URL_PARAMS')) {
            query += urlSpans[i].type;
          } else {
            query += urlSpans[i].key;
          }

          i++;
        }

        i--;
        const queryIndex = i; // Capture the current index

        spans.push(
          <Flex key={queryIndex} alignItems="center" paddingLeft={`${20 * j}px`}>
            <Text
              overflow="hidden"
              whiteSpace="pre-wrap"
              className="urlSpanAll medium-font"
              onClick={() => toggleSelectedUrlSpan(queryIndex)}
              fontWeight={500}
            >
              {query}
            </Text>
            {/* <Checkbox
							size='lg'
							colorScheme='black'
							onChange={() => toggleSelectedUrlSpan(queryIndex)}
						/> */}
            {span.type !== 'STATIC' && (
              <Flex gap={2} ml={2} alignItems="center">
                <Checkbox
                  iconColor={span.type?.includes('URL_PARAMS') ? 'white' : ''}
                  bgColor={span.type?.includes('URL_PARAMS') ? 'black' : ''}
                  borderRadius="5px"
                  size="lg"
                  colorScheme="blackAlpha"
                  isChecked={span.type?.includes('URL_PARAMS')}
                  onChange={() => toggleSelectedUrlSpan(queryIndex)}
                />
                <Text color="#98A2B3">unique to user</Text>
              </Flex>
            )}
          </Flex>
        );
      } else {
        const spanIndex = i;
        spans.push(
          <Flex key={spanIndex} alignItems="center" paddingLeft={`${20 * j}px`}>
            <Text
              overflow="hidden"
              whiteSpace="pre-wrap"
              className="urlSpanAll medium-font"
              onClick={() => toggleSelectedUrlSpan(spanIndex)}
              fontWeight={500}
            >
              {span.type !== 'STATIC' && <span>/ </span>}
              {span.type?.includes('URL_PARAMS') ? span.type : span.key}
            </Text>
            {span.type !== 'STATIC' && (
              <Flex gap={2} ml={2} alignItems="center">
                <Checkbox
                  iconColor={span.type?.includes('URL_PARAMS') ? 'white' : ''}
                  bgColor={span.type?.includes('URL_PARAMS') ? 'black' : ''}
                  borderRadius="5px"
                  size="lg"
                  colorScheme="blackAlpha"
                  isChecked={span.type?.includes('URL_PARAMS')}
                  onChange={() => toggleSelectedUrlSpan(spanIndex)}
                />
                <Text color="#98A2B3">unique to user</Text>
              </Flex>
            )}
          </Flex>
        );
      }

      i++;
      j++;
    }

    return spans;
  };

  return (
    <>
      <Flex direction="column" width="100%" h="100%" justifyContent="space-between">
        <Card variant="outline" flex={1} borderBottomRadius={0} borderBottom="none">
          <CardBody p={0}>
            <VStack
              divider={<StackDivider borderColor="gray.200" />}
              spacing={5}
              align="stretch"
              h="calc(100vh - 250px)"
              overflowY="scroll"
              overflowX="hidden"
              p={7}
            >
              <Box width="100%">
                <Flex direction="column" gap={2}>
                  <Heading className="regular-font">Standardize the request url</Heading>
                  <Text className="medium-font" lineHeight="24px" color="#98A2B3">
                    Select parts of the URL that contain user specific identifiers (e.g.
                    userId, username)
                  </Text>
                  <Flex
                    flexDirection="column"
                    gap={3}
                    mt={2}
                    backgroundColor="gray.50"
                    borderRadius="5px"
                    p={2}
                    minHeight="20vh"
                    maxHeight="30vh"
                    overflowY="auto"
                    overflowX="auto"
                  >
                    {renderUrlSpans(urlSpans)}
                  </Flex>
                </Flex>
              </Box>
              <Box width="100%">
                <VStack align="top" width="full">
                  <Heading className="regular-font">Standardize the request body</Heading>
                  <Text mt={-1} className="medium-font" lineHeight="24px" color="#98A2B3">
                    Click on the keys of request data that contain user specific
                    identifiers (e.g. userId, username)
                  </Text>
                  <Flex alignItems="center" justifyContent="space-between" mt={0}>
                    <Button
                      onClick={resetRegexBody}
                      size="sm"
                      style={{
                        marginRight: '1rem',
                        boxSizing: 'border-box',
                      }}
                      bgColor="black"
                      color="white"
                      colorScheme="black"
                      _hover={{
                        transform: 'scale(1.05)',
                      }}
                    >
                      <Tooltip
                        label="Reset the body to its original state"
                        style={{
                          marginTop: '3rem',
                          marginBottom: '3rem',
                        }}
                        aria-label="A tooltip"
                      >
                        Reset Selections
                      </Tooltip>
                    </Button>
                    <Box>
                      {!selectedNetworkRequest[
                        selectedNetworkIndex
                      ]?.contentType.includes('json') && (
                        <>
                          <Button
                            onClick={handleReplaceRegexBody}
                            isDisabled={!!!selectedText}
                            size="sm"
                            style={{
                              marginRight: '1rem',
                              marginTop: '1rem',
                              boxSizing: 'border-box',
                            }}
                            colorScheme="blackAlpha"
                            bgColor="black"
                          >
                            <Tooltip
                              label="Select the text you want to make dynamic and click this button"
                              aria-label="A tooltip"
                            >
                              Make Dynamic
                            </Tooltip>
                          </Button>
                          <Button
                            onClick={makeFullBodyDynamic}
                            size="sm"
                            style={{
                              marginRight: '1rem',
                              marginTop: '1rem',
                              boxSizing: 'border-box',
                            }}
                            colorScheme="blackAlpha"
                            bgColor="black"
                          >
                            <Tooltip
                              label="Make all the body content dynamic"
                              aria-label="A tooltip"
                            >
                              Make All Dynamic
                            </Tooltip>
                          </Button>
                          <Popover closeOnBlur={false}>
                            <PopoverTrigger>
                              <Icon
                                as={QuestionIcon}
                                w={6}
                                h={6}
                                mt="13px"
                                color="black"
                              />
                            </PopoverTrigger>
                            <PopoverContent color="black">
                              <PopoverArrow />
                              <PopoverHeader>What to do here?</PopoverHeader>
                              <PopoverCloseButton />
                              <PopoverBody>
                                <Box>
                                  <iframe
                                    src="https://www.loom.com/embed/93646bd34665411d9145991f171e6685?sid=62619623-30f4-43e8-ae63-e05854fa9f5f"
                                    allowFullScreen={true}
                                  />
                                  <Text className="medium-font" mt="20px">
                                    Highlight the parts of the body that are not important
                                    in identifying this request, and mark them as dynamic.
                                    Eg. Personal Data, IDs, etc
                                  </Text>
                                </Box>
                              </PopoverBody>
                            </PopoverContent>
                          </Popover>
                        </>
                      )}
                    </Box>
                  </Flex>

                  <Box
                    backgroundColor="gray.50"
                    borderRadius="5px"
                    p={2}
                    minHeight="20vh"
                    maxHeight="40vh"
                    overflowY="auto"
                  >
                    {regexBody !== '' && (
                      <Text ml="-10px" onMouseUp={handleTextSelect} width="100%">
                        <div style={{ overflow: 'auto' }}>
                          {selectedNetworkRequest[
                            selectedNetworkIndex
                          ]?.contentType.includes('json') ? (
                            <>
                              <NormalJsonViewerScreen
                                data={JSON.parse(regexBody)}
                                onItemClick={handleJsonKeyClick}
                                searchQuery=""
                              />
                            </>
                          ) : (
                            <Code
                              style={{
                                whiteSpace: 'pre-wrap',
                                width: '100%',
                                backgroundColor: 'transparent',
                                color: '#000',
                                fontWeight: 600,
                              }}
                            >
                              {regexBody}
                            </Code>
                          )}
                        </div>
                      </Text>
                    )}
                    {regexBody === '' && <Text>No Body</Text>}
                  </Box>
                </VStack>
              </Box>
            </VStack>
          </CardBody>
        </Card>
        <Box w="full" backgroundColor="gray.50" px={30} py={4}>
          <Flex w="full" justifyContent="space-between">
            <Button
              backgroundColor="transparent"
              border="1px solid gray"
              borderRadius={10}
              fontWeight="normal"
              _hover={{
                fontWeight: 'bold',
                transform: 'scale(1.05)',
              }}
              isDisabled={buttonLoading}
              onClick={handleGoBack}
            >
              Back
            </Button>
            <Button
              backgroundColor="black"
              color="white"
              border="1px solid black"
              borderRadius={10}
              fontWeight="normal"
              _hover={{
                transform: 'scale(1.05)',
              }}
              isLoading={buttonLoading}
              onClick={handleNext}
            >
              Next
            </Button>
          </Flex>
        </Box>
      </Flex>
    </>
  );
};
